module.exports = __webpack_public_path__ + "static/nimblewright-schematic-mtg_clb-cfccdb3bc2545f55fdb1b1d76b2063fd.webp";